import LegalShell, { LegalSection } from "../components/LegalShell";

export default function Privacy() {
  const supportEmail = (
    <a
      href="mailto:contactcavilow@gmail.com"
      className="text-[#80FFEA] font-semibold hover:underline"
    >
      contactcavilow@gmail.com
    </a>
  );

  return (
    <LegalShell eyebrow="Legal" title="Privacy Policy">
      <p>
        Cavilow respects your privacy and is committed to keeping your information safe. This Privacy Policy explains
        what information we use, why we use it, and how you can contact us for support or data-related requests.
      </p>

      <LegalSection title="What we collect">
        <p>Cavilow collects limited information required to provide the service.</p>

        <p className="!mt-4">
          <b>Account details</b><br />
          Your name, email address, password which is securely hashed, and country.
        </p>

        <p>
          <b>Resume content for processing</b><br />
          When you upload a PDF or DOCX resume, Cavilow reads and processes the content to provide ATS review, resume
          improvement, job matching, cover letters, and interview preparation.
        </p>
        <p>
          Cavilow does not permanently store uploaded resume files unless you choose to save a generated resume or
          related document inside your account.
        </p>

        <p>
          <b>Generated documents</b><br />
          Resume versions, cover letters, tailored documents, ATS reviews, and interview preparation content created
          through Cavilow, if you choose to save or download them.
        </p>

        <p>
          <b>Job search preferences</b><br />
          Your job title, city, country, industry, experience level, saved jobs, and application tracking details.
        </p>

        <p>
          <b>App usage data</b><br />
          Basic analytics such as page visits and feature usage, used to operate, improve, and secure the service.
        </p>
      </LegalSection>

      <LegalSection title="How we use your data">
        <p>Your information is used only to provide and improve Cavilow's services, including:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Resume improvement</li>
          <li>ATS review</li>
          <li>Job matching</li>
          <li>Tailored cover letters</li>
          <li>Interview preparation</li>
          <li>Application tracking</li>
        </ul>
      </LegalSection>

      <LegalSection title="Resume handling">
        <p>
          Uploaded resumes are processed only to generate the review, improvement, or document requested by the user.
        </p>
        <p>
          Cavilow does not permanently store uploaded resume files unless the user chooses to save a generated resume
          or related document inside their account.
        </p>
      </LegalSection>

      <LegalSection title="Third-party services">
        <p>
          Cavilow may use trusted third-party services to support features such as authentication, file processing,
          analytics, resume review, document generation, and job search links.
        </p>
        <p>
          Job listings and application links may redirect users to third-party platforms such as LinkedIn, Indeed,
          Naukri, Naukrigulf, Bayt, or other job platforms depending on the selected country and location.
        </p>
      </LegalSection>

      <LegalSection title="Your choices">
        <p>
          You can request support, data correction, or deletion of your account and associated data at any time by
          contacting:
        </p>
        <p>{supportEmail}</p>
        <p>Where available, you may also delete your account from the <b>Settings</b> section of the app.</p>
      </LegalSection>

      <LegalSection title="Security">
        <p>
          Passwords are securely hashed. Data is transmitted over HTTPS. Any saved documents are linked only to your
          account.
        </p>
        <p>
          While Cavilow takes reasonable steps to protect your information, no online service can guarantee complete
          security.
        </p>
      </LegalSection>

      <LegalSection title="Updates to this policy">
        <p>
          We may update this Privacy Policy from time to time. If there are important changes, users may be notified
          by email or in-app notice.
        </p>
      </LegalSection>

      <LegalSection title="Contact & Support">
        <p>For support, privacy requests, or account-related help, contact:</p>
        <p>{supportEmail}</p>
      </LegalSection>
    </LegalShell>
  );
}
